@if (!loading()) {
  <div
    class="temperature-box"
    role="group"
    aria-label="location-card"
    data-testid="location-card"
    >
    <header>
      <h2>🌡<span class="label" data-testid="location-name">{{location().name}}</span></h2>
    </header>
    <div class="temperatures">
      <div class="temperature temperature--primary">
        <span class="value" data-testid="location-temperature">{{location().lastMeasurementValue | toFixed}}</span><span class="unit">°C</span>
      </div>
      @if (location().minimalMeasurementValue !== null) {
        <div
          class="temperature temperature--minimal"
          data-testid="location-minimal-temperature"
        >
          <span class="value">Min: <span data-testid="location-minimal-value">{{location().minimalMeasurementValue | toFixed}}</span></span><span class="unit">°C</span>
        </div>
      }
    </div>
    @if (isOutdated()) {
      <div
        class="footer footer--warning footer--warning-outdated"
        >
        <span data-testid="location-outdated">Opóźnione: {{ relativeTime() }}</span>
      </div>
    }
  </div>
} @else {
  <termo-spinner />
}
<div class="arrow"></div>
